import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll position to the top on every route (pathname)
 * change. SPA navigation otherwise preserves the previous page's scroll
 * position, so a new page would open wherever the last one was scrolled to.
 *
 * The effect is client-only (SSG prerender skips effects). In-page hash links
 * (`/page#section`) are left alone so anchor navigation still works.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
